import { Badge } from "@/components/ui/badge";
import ResourceManager from "@/components/admin/ResourceManager";

const fields = [
    { name: "title", label: "Title", type: "text", required: true },
    { name: "slug", label: "Slug", type: "text", help: "Leave empty to auto-generate" },
    { name: "client_business_type", label: "Client business type", type: "text", placeholder: "Restaurant, salon..." },
    { name: "problem", label: "Problem", type: "textarea", rows: 4, required: true },
    { name: "solution", label: "Solution", type: "textarea", rows: 5, required: true },
    { name: "features_delivered", label: "Features delivered", type: "tags", help: "One per line" },
    { name: "results", label: "Results", type: "textarea", rows: 3, required: true },
    { name: "images", label: "Project images", type: "images" },
    { name: "related_service_slugs", label: "Related service slugs", type: "tags", help: "One slug per line, e.g. website-development" },
    { name: "is_featured", label: "Featured", type: "switch", toggleLabel: "Highlighted as case study" },
    { name: "order", label: "Sort order", type: "number" },
    { name: "seo_title", label: "SEO title", type: "text" },
    { name: "seo_description", label: "SEO description", type: "textarea", rows: 2 },
    { name: "og_image", label: "Open Graph image", type: "image" },
];

const columns = [
    { key: "title", label: "Title" },
    { key: "client_business_type", label: "Client" },
    {
        key: "is_featured",
        label: "Featured",
        render: (r) =>
            r.is_featured ? (
                <Badge className="bg-slate-950 text-white">Featured</Badge>
            ) : (
                <span className="text-slate-400 text-xs">—</span>
            ),
    },
    { key: "order", label: "Order" },
];

export default function CaseStudiesPage() {
    return (
        <ResourceManager
            title="Case Studies"
            description="Real client stories showing the problem you solved and the results delivered."
            endpoint="case-studies"
            columns={columns}
            fields={fields}
            testidPrefix="case-studies"
        />
    );
}
